import { hydrateConditionWithIds } from "src/components/audiences/utils";
import type { SavedCohortDefinition } from "src/pages/analytics/state";
import type {
  AdHocAudience,
  BaseAudience,
  ParentModel,
  SelectedAudience,
} from "src/pages/analytics/types";
import type { VisualQueryFilter } from "src/types/visual";

export const convertSavedCohortsToSelectedAudiences = ({
  cohorts,
  audienceOptions,
  parentModel,
}: {
  cohorts: SavedCohortDefinition[];
  audienceOptions: SelectedAudience[];
  parentModel: Pick<ParentModel, "id" | "name">;
}): SelectedAudience[] => {
  const selectedAudiences: SelectedAudience[] = [];
  cohorts?.forEach(({ cohort, cohort_definition }) => {
    let audience: SelectedAudience | undefined;
    if (cohort?.id) {
      // The id comes back as a number, but graphql type labels it as string
      audience = audienceOptions.find(
        ({ id }) => id === (cohort.id as unknown as number),
      );
    } else {
      if (cohort_definition?.filter?.conditions?.length) {
        // For adhoc cohorts
        const filter: VisualQueryFilter | undefined = hydrateConditionWithIds(
          cohort_definition?.filter,
        );

        audience = {
          id: parentModel.id,
          name: cohort_definition?.name ?? parentModel.name,
          splits: [],
          filter,
          subsetIds: cohort_definition?.subsetIds ?? [],
        } as AdHocAudience;
      } else {
        // For segmenting by the parent model
        audience = {
          id: parentModel.id,
          name: parentModel.name ?? cohort_definition?.name,
          splits: [],
          subsetIds: cohort_definition?.subsetIds ?? [],
        } as BaseAudience;
      }
    }

    if (audience) {
      selectedAudiences.push(audience);
    }
  });

  return selectedAudiences;
};
